import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 284px;
  height: 183px;
  border-radius: ${({ theme }) => theme.rounded.x2};

  position: relative;
  background-size: cover;
`;

export const User = styled.div`
  position: absolute;
  left: ${({ theme }) => theme.spacing.x5};
  bottom: ${({ theme }) => theme.spacing.x4};
  font-family: IBM Plex Mono;
`;
export const UserName = styled.div`
  letter-spacing: 2px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.white};
  font-size: ${({ theme }) => theme.fs.xs};
`;
export const UserNumber = styled.div`
  letter-spacing: 2px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.white};
  font-size: ${({ theme }) => theme.fs.xs};
`;

export const UserDate = styled.div`
  color: ${({ theme }) => theme.palette.white_70};
  font-size: ${({ theme }) => theme.fs.xxs};
`;
export const UserDateSpan = styled.span`
  color: ${({ theme }) => theme.palette.white};
  font-size: ${({ theme }) => theme.fs.xs};
`;
